import { render } from "./LayoutData.vue?vue&type=template&id=7be7b76f&lang=pug"
import script from "./LayoutData.vue?vue&type=script&lang=js"
export * from "./LayoutData.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__